import React, { useEffect, useState, useRef } from "react";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { MdClear } from "react-icons/md";
import "./style/dragndropstyle.css";
import { useTranslation } from "react-i18next";
import AppButton from "../../shared/AppButton";

const DragNdrop = ({ width, height, formik }) => {
  const [files, setFiles] = useState("");
  const { t, i18n } = useTranslation();
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files[0];
    if (selectedFiles) {
      setFiles(selectedFiles);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files[0];
    if (droppedFiles) {
      setFiles(droppedFiles);
    }
  };

  const handleRemoveFile = () => {
    setFiles("");
    formik.setFieldValue("payerListFile", null);
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  useEffect(() => {
    formik.setFieldValue("payerListFile", files);
  }, [files]);

  return (
    <section className="drag-drop" style={{ width: width, height: height }}>
      <div
        className={`document-uploader !p-2 !min-h-[100px] ${
          files ? "upload-box active" : "upload-box"
        }`}
        onDrop={handleDrop}
        onDragOver={(event) => event.preventDefault()}
      >
        <div className="upload-info !mb-2">
          <AiOutlineCloudUpload
            className={`!text-[28px] ${
              i18n.language == "ar" ? "!ml-2" : "!mr-2"
            }`}
          />
          <div>
            <p className="text-[12px] font-bold leading-tight">
              {t("Drag and drop your files here")}
            </p>
            <p className="text-[10px] text-gray-500">
              {t("Limit 4000 data per file. Supported file: .XLSX")}
            </p>
          </div>
        </div>

        <input
          type="file"
          hidden
          ref={fileInputRef}
          onChange={handleFileChange}
          accept=".xlsx"
        />

        <AppButton
          label={t("Browse files")}
          onClick={triggerFileInput}
          className="!h-[24px] !px-4 !text-[11px]"
          bgColor="#0070C2"
        />

        {files && (
          <div className="file-list !mt-2 !gap-1">
            <div className="file-list__container">
              <div className="file-item !p-1 !rounded-[4px]">
                <div className="file-info">
                  <p className="!text-[11px] truncate max-w-[200px]">
                    {files.name}
                  </p>
                </div>
                <div className="file-actions ml-2">
                  <MdClear
                    className="!text-[14px]"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveFile();
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DragNdrop;
